
import { supabase } from "@/integrations/supabase/client";

export const performBasicSearch = async (query: string) => {
  try {
    const searchTerms = query.toLowerCase().split(' ');
    
    let dbQuery = supabase
      .from('TUI')
      .select('*')
      .not('imageURL', 'is', null)
      .not('name', 'is', null);

    // Build comprehensive search conditions for each term
    const searchConditions: string[] = [];
    
    searchTerms.forEach(term => {
      // Add comprehensive search across all relevant fields
      searchConditions.push(
        `name.ilike.%${term}%`,
        `description.ilike.%${term}%`,
        `descriptionLong.ilike.%${term}%`,
        `city.ilike.%${term}%`,
        `country.ilike.%${term}%`,
        `region.ilike.%${term}%`,
        `facilities.ilike.%${term}%`,
        `extraInfo.ilike.%${term}%`,
        `categories.ilike.%${term}%`,
        `subcategories.ilike.%${term}%`
      );
    });

    if (searchConditions.length > 0) {
      dbQuery = dbQuery.or(searchConditions.join(','));
    }

    const { data, error } = await dbQuery.limit(50);
    
    if (error) throw error;
    
    console.log(`Basic search found ${data?.length || 0} results`);
    
    // Validate and clean the data
    const validatedData = (data || []).map((vacation: any) => ({
      ...vacation,
      name: vacation.name || "Onbekende vakantie",
      imageURL: vacation.imageURL || "/placeholder.svg"
    }));
    
    return validatedData;
  } catch (error: any) {
    console.error('Basic search error:', error);
    throw error;
  }
};
